import { useContext } from 'react';
import { MapContext } from 'context/map';

const useMapContext = () => {
  return useContext(MapContext);
};

export default useMapContext;
